// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Settings resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class SettingsClient {
  constructor(private readonly http: HttpClient) {}

  /** Create Api Key via the Inferrex API. */
  async createApiKey(request: { displayName?: string; scopes?: string[]; expiresInDays?: number }, requestOptions?: RequestOptions): Promise<{ id: string; key: string; prefix: string; displayName: string | null; scopes: string[]; expiresAt: string | null; createdAt: string }> {
    return this.http.post<{ id: string; key: string; prefix: string; displayName: string | null; scopes: string[]; expiresAt: string | null; createdAt: string }>('/v1/settings/api-keys', request, requestOptions);
  }

  /** List Api Keys via the Inferrex API. */
  async listApiKeys(): Promise<{ keys: { id: string; key_prefix: string; display_name: string | null; scopes: string; last_used_at: string | null; expires_at: string | null; is_active: boolean; created_at: string }[] }> {
    return this.http.get<{ keys: { id: string; key_prefix: string; display_name: string | null; scopes: string; last_used_at: string | null; expires_at: string | null; is_active: boolean; created_at: string }[] }>('/v1/settings/api-keys');
  }

  /** Revoke Api Key via the Inferrex API. */
  async revokeApiKey(keyId: string, requestOptions?: RequestOptions): Promise<{ revoked: boolean }> {
    return this.http.request<{ revoked: boolean }>('DELETE', `/v1/settings/api-keys/${keyId}`, undefined, undefined, requestOptions);
  }
}
